import { AtSign, BadgeCheck, MessageCircle, ThumbsUp } from "lucide-react";

// De onde a conversa veio. O que separa o WhatsApp oficial do não oficial é
// ter uma integração da Meta por trás: com ela é Cloud API, sem ela é a
// sessão do celular.
export const canalDoTicket = (ticket) => {
  const conexao = ticket?.whatsapp;
  const canal = conexao?.channel || "whatsapp";

  if (canal === "facebook") {
    return {
      chave: "facebook",
      rotulo: "Facebook",
      icone: ThumbsUp,
      classe: "bg-sky-500 text-white",
      classePill: "bg-sky-500/10 text-sky-600 dark:text-sky-400",
      corSelo: "#4267B2",
    };
  }

  if (canal === "instagram") {
    return {
      chave: "instagram",
      rotulo: "Instagram",
      icone: AtSign,
      classe: "bg-pink-500 text-white",
      classePill: "bg-pink-500/10 text-pink-600 dark:text-pink-400",
      corSelo: "#E1306C",
    };
  }

  if (canal === "whatsapp_official" || conexao?.metaIntegrationId) {
    return {
      chave: "whatsapp-oficial",
      rotulo: "WhatsApp Oficial",
      icone: BadgeCheck,
      classe: "bg-emerald-600 text-white",
      classePill: "bg-emerald-500/10 text-emerald-600 dark:text-emerald-400",
      corSelo: "#128C7E",
    };
  }

  return {
    chave: "whatsapp",
    rotulo: "WhatsApp",
    icone: MessageCircle,
    classe: "bg-emerald-500 text-white",
    classePill: "bg-primary/10 text-primary",
    corSelo: "#25D366",
  };
};

export default canalDoTicket;
